import { useState } from 'react';

import styled from '@emotion/styled';

import LocalNavItemsPopup, { PopupVerticalNavItem } from './LocalNavItemsPopup';
import LocalNavMoreButton from './LocalNavMoreButton';
import { HeaderZindex } from '../../../constants/header';

interface Props {
  verticalItems: PopupVerticalNavItem[];
  showIcon?: boolean;
}

export default function RestLocalNavItems({ verticalItems, showIcon = false }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const handleMouseEnter = () => {
    const headerEl = document.getElementById('mrt-main-header');

    if (headerEl) {
      headerEl.style.zIndex = `${HeaderZindex.hover}`;
    }
    setIsOpen(true);
  };
  const handleMouseLeave = () => {
    const headerEl = document.getElementById('mrt-main-header');

    if (headerEl) {
      headerEl.style.zIndex = `${HeaderZindex.default}`;
    }
    setIsOpen(false);
  };

  return (
    <Container onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <LocalNavMoreButton />
      <LocalNavItemsPopup isOpen={isOpen} verticalItems={verticalItems} showIcon={showIcon} />
    </Container>
  );
}

const Container = styled.div`
  position: relative;
`;
